module.exports = __webpack_public_path__ + "img/settings.6441a6be.png";